var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"primary u-fixed",attrs:{"fluid":"","fill-height":""}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","sm":"4"}},[_c('v-img',{staticClass:"c-img-logo",attrs:{"src":require("@/assets/AVIZVFX.png")}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }